export interface LegacyGroup {
  id: string
  name: string
}

export interface LegacyGroupOffice {
  id: string
  groupId: string
  groupName: string
  officeName: string
  officeType: '직영' | '가맹'
  createdAt: string
}

export const legacyGroups: LegacyGroup[] = Array.from({ length: 14 }, (_, index) => ({
  id: `${index + 1}`,
  name: `모의그룹 ${String(index + 1).padStart(2, '0')}`,
}))

const groupCounts = [7, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1]

export const legacyGroupedOffices: LegacyGroupOffice[] = groupCounts.flatMap((count, groupIndex) =>
  Array.from({ length: count }, (_, officeIndex) => {
    const previous = groupCounts.slice(0, groupIndex).reduce((sum, value) => sum + value, 0)
    const index = previous + officeIndex + 1
    return {
      id: `${index}`,
      groupId: legacyGroups[groupIndex].id,
      groupName: legacyGroups[groupIndex].name,
      officeName: `모의지점 ${String(index).padStart(2, '0')}`,
      officeType: index % 3 === 0 ? '가맹' : '직영',
      createdAt: `2026-${String((index % 8) + 1).padStart(2, '0')}-${String((index % 19) + 1).padStart(2, '0')}`,
    }
  }),
)

export const legacyUngroupedOffices: LegacyGroupOffice[] = Array.from({ length: 5 }, (_, index) => ({
  id: `${index + 26}`,
  groupId: '',
  groupName: '',
  officeName: `미지정 모의지점 ${String(index + 1).padStart(2, '0')}`,
  officeType: index % 2 ? '가맹' : '직영',
  createdAt: '',
}))
